import { Spinner, ArticleHeading4 } from '@cian/ui-kit';
import React from 'react';
import styles from './styles.css';
import cn from 'clsx';
import { useIsDesktop } from '../../hooks/common';

interface ILoaderProps {
  text: string;
}

export const Loader: React.FC<ILoaderProps> = ({ text }) => {
  const isDesktop = useIsDesktop();

  return (
    <div className={cn(styles['wrapper'], isDesktop && styles['desktop'])}>
      <Spinner size={36} colorType="main" />
      <ArticleHeading4>{text}</ArticleHeading4>
    </div>
  );
};
